import { Radio, withStyles } from "@material-ui/core";

const styles = {
  root: {
    color: '#999999', // default color
    padding: 5,
    '&$checked': {
      color: '#3994DE' // blue when checked
    }
  },
  checked: {}
};

export const StyledRadio = withStyles(styles)(({ classes, ...props }) => (
  <Radio
    color="default"
    classes={{
      root: classes.root,
      checked: classes.checked
    }}
    {...props}
  />
));
